import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import GolfUpdateRowInactive from "./GolfUpdateRowInactive";
import GolfStatusBadge from "./GolfStatusBadge";

class GolfUpdateRowNew extends Component {
    handleChangeStatus = event => {
        let newState = this.props.status ? 0 : 1;
        this.props.callbackUpdate({
            name: this.props.golf,
            status: newState
        });
    };
    handleChange = (event,day) => {
        this.props.callbackOnChange(event.target.id, event.target.value, day);
    };
    handleAddTimeslot = event => {
        console.log("handleTimeSlothandler: ");
        console.log(event);
        this.props.handleAddTimeslot(event);
        console.log("Timeslot added");
    };
    deleteTimeslot = (golf,slot) => {
        console.log("Ready to delete timeslot");
        console.log(golf);
        console.log("which slot?");
        console.log(golf.slot);
        this.props.handleDeleteTimeslot(golf.golf, golf.slot, this.props.day);    
    };
    render() {

        //console.log("Slot length: "+this.props.slots.length)
        if (this.props.slots.length === 0)
            return (
                <GolfUpdateRowInactive
                    golf={this.props.golf}
                    tp={this.props.tp}
                    handleAddTimeslot={this.props.handleAddTimeslot}
                    day={this.props.day}
                />);
        else
            return (
                this.props.slots.map((slot, i) => (

                    <tr key={i+this.props.day}>
                        {i === 0 ? (<td>
                            <label className="form-check-label" htmlFor="defaultCheck1 p-2" >
                                {this.props.golf}
                            </label>
                        </td>
                        ) : (<td></td>)}

                        {i === 0 ?
                            (<td><GolfStatusBadge curTime={this.props.curTime} slots={this.props.slots} /></td>)
                            :
                            (<td></td>)}

                        {i === 0 ?
                            (<td>
                                <Button
                                    key={this.props.golf + "-slot-" + i+this.props.day}
                                    id={this.props.golf}
                                    variant="link"
                                    onClick={() => this.handleAddTimeslot({ golf: this.props.golf, day: this.props.day })}
                                >Add</Button>

                            </td>)
                            :
                            (<td></td>)}

                        { this.props.golf.includes("GA") ?
                        ( <td>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={slot.tp}
                                id={"tp-" + this.props.golf + "-slot-" + i}
                                key={"tp-" + this.props.tp + "-slot-" + i+this.props.day}
                                //onChange={() => this.handleChangeStatus({ golf: this.props.golf })}
                                onClick={(event) => this.handleChange(event,this.props.day)}

                            />
                        </td>)
                        :
                        (<td id={"tp-" + this.props.golf + "-slot-" + i}
                        key={"tp-" + this.props.tp + "-slot-" + i} ></td>)}
                        <td>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id={"FL-" + this.props.golf + "-slot-" + i}
                                key={"FL-" + this.props.golf + "-slot-" + i}
                                placeholder={slot.FL}
                                onChange={event => this.handleChange(event,this.props.day)}

                            />
                        </td>

                        <td>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id={"sh-" + this.props.golf + "-slot-" + i}
                                key={"sh-" + this.props.golf + "-slot-" + i}
                                placeholder={slot.sh}
                                onChange={event => this.handleChange(event,this.props.day)}

                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id={"sm-" + this.props.golf + "-slot-" + i}
                                key={"sm-" + this.props.golf + "-slot-" + i}
                                placeholder={slot.sm}
                                onChange={event => this.handleChange(event,this.props.day)}

                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id={"eh-" + this.props.golf + "-slot-" + i}
                                key={"eh-" + this.props.golf + "-slot-" + i}
                                placeholder={slot.eh}
                                onChange={event => this.handleChange(event,this.props.day)}

                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id={"em-" + this.props.golf + "-slot-" + i}
                                key={"em-" + this.props.golf + "-slot-" + i}
                                placeholder={slot.em}
                                onChange={event => this.handleChange(event,this.props.day)}

                            />
                        </td>
                        <td>
                            <a href="#">
                                <span
                                    className="oi oi-trash"
                                    onClick={() =>
                                        this.deleteTimeslot({
                                            golf:this.props.golf,
                                            slot: i,
                                            day: this.props.day
                                        })
                                    }
                                ></span>
                            </a>
                        </td>
                    </tr>
                ))
            )
    }
}

export default GolfUpdateRowNew;
